import { createFileRoute } from '@tanstack/react-router'
import EditionTechnicalDescription from 'Edition/components/sections/Layout/EditionTechnicalDescription'

export const Route = createFileRoute('/work/$workId_/edition/$editionId/technicaldescription')({
    component: EditionTechnicalDescription,
})
